import { SET_MASTER_PAYMENT_TERM } from "./actionType";

const init = {
  data: [],
  isFetch: false,
};

export default function reducer(state = init, action) {
  switch (action.type) {
    case SET_MASTER_PAYMENT_TERM:
      return {
        data: action.payload,
        isFetch: true,
      };
    default:
      return state;
  }
}
